import { CloseOutlined, DownloadOutlined, EditOutlined } from '@ant-design/icons';
import { Modal, Space, Spin } from 'antd';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Svg from '../../components/SVG/SVG';
import { session } from '../../helpers/helpers';
import { useContactStore } from '../../hooks/useContactStore';
import { apiInstance } from '../../utils/api';
import { downloadFile } from '../../utils/urlImgToBlob';
import RequestItemAttachments from './RequestItemAttachments';

const adminMovingCategory = '5f72e68a-8bbb-4660-b442-e36df955db2e';
const adminTemporaryEntryCategory = '88a699c2-b2de-4bde-9ffd-c038a9a174f9';
const cardIssuanceCategory = '2a92dbea-2b8c-4a63-b3f6-ea4135f981d7';
const STATUS_CANCELLED = '6e5f4218-f46b-1410-fe9a-0050ba5d6c38';
const STATUS_APPROVAL = '5b855ae0-e659-413c-ad3d-86d4ad5f1bb7';
const STATUS_SKD_PROCESSED = '3e7f420c-f46b-1410-fc9a-0050ba5d6c38';

const RequestItem = () => {
  const [request, setRequest] = useState({});
  const [references, setReferences] = useState(null);
  const { id } = useParams();
  const [, setMessages] = useState([]);
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loadingZoneModal, setLoadingZoneModal] = useState(false);
  const [imageLoadingZoneSmall, setImageLoadingZoneSmall] = useState(null);
  const [imageLoadingZoneFull, setImageLoadingZoneFull] = useState(null);
  const [invoice, setInvoice] = useState(null);
  const history = useHistory();

  const token = session.get('token');

  const serviceCategoryRequest = request?.ServiceCategory?.value;
  const altitudeServiceCategories = new Set([
    '5369e6b8-4f16-45b3-8114-bdeeb2ca4969', // Маркетингові роботи (адміністрація)
    'aa5a0901-0ed4-4191-853e-16c33c7d3b57', // Ремонтні роботи (експлуатація)
    'ddc7cc8b-2808-40e5-84a9-97ef0fc008fb', // Роботи (адміністрація)
  ]);
  const hasAltitudeValue =
    request?.RespAltitudeWorks !== undefined && request?.RespAltitudeWorks !== null;
  const shouldShowAltitudeWorks =
    hasAltitudeValue && altitudeServiceCategories.has(serviceCategoryRequest);
  const { currentContactStore } = useContactStore();
  const isContractorStore =
    currentContactStore?.type?.crmId === 'f3c0ce97-53e6-df11-971b-001d60e938c6';

  const ROUTES = {
    REQUEST: new URL(
      `${process.env.REACT_APP_API_URL}/api/crm/get-data?id=${id}&type=requestQuery`
    ),
    MESSAGES: new URL(`${process.env.REACT_APP_API_URL}/api/crm/get-data?id=${id}&type=message`),
    POST_MESSAGE: `${process.env.REACT_APP_API_URL}/api/post-data?id=${id}&type=message`,
    UPDATE_REQUEST: `${process.env.REACT_APP_API_URL}/api/post-data?type=update-request&id=${id}`,
    REFERENCES: `${process.env.REACT_APP_API_URL}/api/requests/references`,
  };

  const handleCancelClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirmCancel = () => {
    setShowConfirmModal(false);
    setLoadingCancel(true);

    const payload = {
      Status: STATUS_CANCELLED,
      Symptoms: `Звернення скасоване користувачем ${moment().format('DD.MM.YYYY')}, ${
        request?.Symptoms
      } `,
    };

    apiInstance(ROUTES.REQUEST, 'GET')
      .then((currentRequest) => {
        // Allow cancellation for all statuses
        return apiInstance(ROUTES.UPDATE_REQUEST, 'POST', payload);
      })
      .then(() => {
        return apiInstance(ROUTES.REQUEST, 'GET');
      })
      .then((updatedRequest) => {
        setRequest(updatedRequest.rows[0]);
        history.push('/requests');
      })
      .catch((error) => {
        console.error('Помилка при скасуванні звернення:', error);
        setErrorMessage(error.message);
        setShowErrorModal(true);
      })
      .finally(() => {
        setLoadingCancel(false);
      });
  };

  const handleCancelModal = () => {
    setShowConfirmModal(false);
  };

  const handleErrorModalClose = () => {
    setShowErrorModal(false);
    setErrorMessage('');
  };

  // Загрузка данных запроса и референсов
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    apiInstance(ROUTES.REQUEST, 'GET').then((response) => {
      console.log('API Response (ROUTES.REQUEST):', response);
      const requestData = response.rows[0];
      console.log('Request Data:', requestData);
      console.log('Request.SuLoadingZone:', requestData?.SuLoadingZone);
      setRequest(requestData);

      // Fetch invoice by Case ID
      if (requestData?.Id) {
        const INVOICE_BY_CASE_ROUTE = new URL(
          `${process.env.REACT_APP_API_URL}/api/crm/get-data?id=${requestData.Id}&type=invoiceByCase`
        );

        apiInstance(INVOICE_BY_CASE_ROUTE, 'GET')
          .then((invoiceResponse) => {
            console.log('Invoice Response:', invoiceResponse);
            if (invoiceResponse.rows && invoiceResponse.rows.length > 0) {
              setInvoice(invoiceResponse.rows[0]);
            }
          })
          .catch((error) => {
            console.error('Ошибка загрузки рахунка:', error);
          });
      }
    });

    apiInstance(ROUTES.REFERENCES, 'GET')
      .then((res) => {
        console.log('References API Response:', res);
        console.log('References.SuLoadingZone:', res?.SuLoadingZone);
        setReferences(res);
      })
      .catch((error) => {
        console.error('Ошибка загрузки референсов:', error);
      });

    apiInstance(ROUTES.MESSAGES, 'GET').then((message) => {
      console.log('Messages Data:', message);
      setMessages(message);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Определение currentLoadingZoneData на основе references
  const currentLoadingZoneData = useMemo(() => {
    console.log('Computing currentLoadingZoneData...');
    console.log('request.SuLoadingZone:', request?.SuLoadingZone);
    console.log('references.SuLoadingZone:', references?.SuLoadingZone);

    if (!request?.SuLoadingZone || !references?.SuLoadingZone) {
      console.log('No SuLoadingZone or references.SuLoadingZone available.');
      return null;
    }

    const zoneId = request.SuLoadingZone?.value || request.SuLoadingZone?.Id;
    console.log('Zone ID:', zoneId);

    const foundZone = references.SuLoadingZone.find((zone) => zone.Id === zoneId);
    console.log('Found Zone:', foundZone);

    return foundZone || null;
  }, [request, references]);

  // Обработка изображений
  useEffect(() => {
    console.log('useEffect for image processing...');
    console.log('currentLoadingZoneData:', currentLoadingZoneData);

    if (
      currentLoadingZoneData &&
      currentLoadingZoneData.ZoneImage &&
      Array.isArray(currentLoadingZoneData.ZoneImage) &&
      currentLoadingZoneData.ZoneImage.length > 0
    ) {
      const imageData = currentLoadingZoneData.ZoneImage[0];
      console.log('ZoneImage[0]:', imageData);
      const baseUrl = process.env.REACT_APP_API_URL || '';
      console.log('baseUrl:', baseUrl);
      const formats = imageData.formats || {};
      console.log('Image Formats:', formats);

      const smallImage =
        (formats.medium?.url && `${baseUrl}${formats.medium.url}`) ||
        (formats.small?.url && `${baseUrl}${formats.small.url}`) ||
        (imageData.url && `${baseUrl}${imageData.url}`) ||
        null;
      console.log('smallImage URL:', smallImage);

      const fullImage = imageData.url ? `${baseUrl}${imageData.url}` : null;
      console.log('fullImage URL:', fullImage);

      setImageLoadingZoneSmall(smallImage);
      setImageLoadingZoneFull(fullImage);
    } else {
      console.log('No valid ZoneImage data.');
      setImageLoadingZoneSmall(null);
      setImageLoadingZoneFull(null);
    }
  }, [currentLoadingZoneData]);

  const handleClickLoadingZone = () => {
    console.log('Opening loading zone modal...');
    setLoadingZoneModal(true);
  };

  if (isEmpty(request)) {
    console.log('Request is empty, showing loading spinner.');
    return (
      <Space className="loading" size="middle">
        <Spin size="large" />
      </Space>
    );
  }

  const categoryMapSuWorkDesc = {
    // [adminMovingCategory]: 'Кількість товару',
    [adminTemporaryEntryCategory]: 'Мета візиту',
  };
  const categoryMapSymptoms = {
    [adminTemporaryEntryCategory]: 'Доступ на вхід для',
  };

  return (
    <div className="request-page-item boxes">
      <div className="box request-item-header">
        <div className="text-black-medium-f22-l30">Сторінка звернення</div>
        <div className="request-item-header-btns">
          {request?.Status?.value === '3859c6e7-cbcb-486b-ba53-77808fe6e593' && (
            <>
              <Link to={`/edit-request/${id}`} className="request-item-header__link">
                <Button
                  className="request-item-btn request-item-btn--edit"
                  text="Редагувати"
                  bg="turquoise"
                  style={{ width: '150px' }}
                >
                  <EditOutlined />
                </Button>
              </Link>
            </>
          )}
          {(() => {
            if (request?.Category?.value === cardIssuanceCategory) {
              return ![STATUS_APPROVAL, STATUS_CANCELLED, STATUS_SKD_PROCESSED].includes(
                request?.Status?.value
              );
            }
            return request?.Status?.value !== STATUS_CANCELLED;
          })() && (
            <Button
              className="request-item-btn request-item-btn--cancel"
              text="Скасувати"
              bg="orange"
              onClick={handleCancelClick}
              loading={loadingCancel}
              style={{ width: '150px' }}
            >
              <CloseOutlined />
            </Button>
          )}
        </div>
      </div>
      <Modal
        className="success-modal"
        onCancel={handleCancelModal}
        open={showConfirmModal}
        footer={
          <div className="ant-btn-wrapper">
            <Button style={{ width: '120px' }} onClick={handleCancelModal} text="Ні" bg="orange" />
            <Button
              style={{ width: '120px' }}
              text="Так"
              bg="turquoise"
              onClick={handleConfirmCancel}
              loading={loadingCancel}
            />
          </div>
        }
      >
        <div className="success-modal__wrapper">
          <div className="text-black-medium-f22-l30">Скасування звернення</div>
          <div className="text-grey-dark-normal-f16-l28">Ви впевнені, що хочете скасувати?</div>
        </div>
      </Modal>
      <Modal
        className="success-modal"
        open={showErrorModal}
        footer={null}
        onCancel={handleErrorModalClose}
      >
        <div className="success-modal__wrapper">
          <div className="text-black-medium-f22-l30">Помилка</div>
          <div className="text-grey-dark-normal-f16-l28">{errorMessage}</div>
        </div>
      </Modal>
      <div className="request-history-item-content">
        <div className="boxes__col request-info">
          <div className="box">
            <div className="request-info-header">
              <div className="text-black-medium-f18-l28">{request.Subject}</div>
              <div
                className="request-info-header-status"
                style={{
                  color:
                    request.Status?.value === '3859c6e7-cbcb-486b-ba53-77808fe6e593' // Новый статус
                      ? '#DB3EB1' // Синий для "Нове"
                      : request.Status?.value === STATUS_CANCELLED
                      ? '#C03221' // Красный для "Скасовано"
                      : request.Status?.value === 'f063ebbe-fdc6-4982-8431-d8cfa52fedcf'
                      ? '#1AA053' // Оранжевий для "Погоджено" FFD329
                      : '#9A18FF', // Зеленый для "Виконано" и других статусов
                }}
              >
                {request.Status?.displayValue}
              </div>
            </div>
            <div className="request-info-list">
              <div className="request-info-item">
                <div className="text-black-normal-f14-l20">ID звернення</div>
                <div className="text-black-normal-f16-l28">{request.Number}</div>
              </div>
              {request?.Category?.displayValue && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Тип звернення</div>
                  <div className="text-black-normal-f16-l28">{request.Category?.displayValue}</div>
                </div>
              )}
              {request?.ServiceCategory?.displayValue && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Категорія сервісу</div>
                  <div className="text-black-normal-f16-l28">
                    {request.ServiceCategory?.displayValue}
                  </div>
                </div>
              )}
              {shouldShowAltitudeWorks && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">
                    Роботи на висоті (драбина, вежа-тура тощо)
                  </div>
                  <div className="text-black-normal-f16-l28">
                    {request.RespAltitudeWorks ? 'Так' : 'Ні'}
                  </div>
                </div>
              )}
              {request?.SuStartWork && request?.SuEndWork && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Дата/період</div>
                  <div className="text-black-normal-f16-l28">
                    {moment(request.SuStartWork).format('DD.MM.YYYY HH:mm')} –{' '}
                    {moment(request.SuEndWork).format('DD.MM.YYYY HH:mm')}
                  </div>
                </div>
              )}
              {request?.SuWorkDescription && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">
                    {categoryMapSuWorkDesc[serviceCategoryRequest] || 'Опис робіт'}
                  </div>
                  <div className="text-black-normal-f16-l28">{request.SuWorkDescription}</div>
                </div>
              )}
              {request?.SuContractorType?.displayValue && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Виконавець робіт</div>
                  <div className="text-black-normal-f16-l28">
                    {request.SuContractorType.displayValue}
                  </div>
                </div>
              )}

              {request?.SuServiceSubCategory?.displayValue && 
               request.SuServiceSubCategory.displayValue !== 'Активності орендарів' && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Підкатегорія звернення</div>
                  <div className="text-black-normal-f16-l28">
                    {request.SuServiceSubCategory?.displayValue}
                  </div>
                </div>
              )}

              {request?.RespNightWork && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Виконавці робіт</div>
                  <div className="text-black-normal-f16-l28">{request.RespNightWork}</div>
                </div>
              )}

              {request?.SuClaimDepartment?.displayValue && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Департамент</div>
                  <div className="text-black-normal-f16-l28">
                    {request.SuClaimDepartment.displayValue}
                  </div>
                </div>
              )}
              {request?.SuTenantResonsible && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Відповідальна особа заявника</div>
                  <div className="text-black-normal-f16-l28">{request.SuTenantResonsible}</div>
                </div>
              )}
              {request?.SuTelNumberTenant && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Телефон відповідальної особи</div>
                  <div className="text-black-normal-f16-l28">{request.SuTelNumberTenant}</div>
                </div>
              )}
              {request?.RespContractorTenantResonsible && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">
                    Відповідальна особа підрядної організації
                  </div>
                  <div className="text-black-normal-f16-l28">
                    {request.RespContractorTenantResonsible}
                  </div>
                </div>
              )}
              {request?.RespContractorTelNumberTenant && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">
                    Телефон відповідального підрядної організації
                  </div>
                  <div className="text-black-normal-f16-l28">
                    {request.RespContractorTelNumberTenant}
                  </div>
                </div>
              )}
              {request?.RespContractorName && !isContractorStore && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Назва підрядної організації</div>
                  <div className="text-black-normal-f16-l28">{request.RespContractorName}</div>
                </div>
              )}
              {request?.SuLoadingZone?.displayValue && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Зона завантаження</div>
                  <div className="text-black-normal-f16-l28">
                    {request.SuLoadingZone.displayValue}
                  </div>
                  {imageLoadingZoneSmall && (
                    <img
                      className="loading-zone-img"
                      src={imageLoadingZoneSmall}
                      alt="Зона завантаження"
                      title="Відкрийте щоб переглянути або завантажити"
                      onClick={handleClickLoadingZone}
                      style={{ marginTop: 8, cursor: 'pointer', maxWidth: '600px' }} // Большой размер
                    />
                  )}
                </div>
              )}
              {request?.SuCarNumber && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">Номер авто</div>
                  <div className="text-black-normal-f16-l28">{request.SuCarNumber}</div>
                </div>
              )}
              {request?.Attachments?.[0]?.Id && <RequestItemAttachments request={request} />}
              {invoice && invoice.FileId && (
                <div className="request-info-item" style={{ marginTop: '20px' }}>
                  <div className="text-black-normal-f14-l20">Рахунок</div>
                  <div
                    className="text-black-normal-f16-l28"
                    onClick={() =>
                      downloadFile(
                        `${process.env.REACT_APP_API_URL}/api/files?fileId=${invoice.FileId}&type=receipt`
                      )
                    }
                    style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                  >
                    <span>{invoice.Number || 'Рахунок'}</span>
                    <DownloadOutlined style={{ marginLeft: 8, fontSize: 16 }} />
                  </div>
                </div>
              )}
              {request?.Symptoms && serviceCategoryRequest !== adminMovingCategory && (
                <div className="request-info-item">
                  <div className="text-black-normal-f14-l20">
                    {categoryMapSymptoms[serviceCategoryRequest] || 'Коментарі до звернення'}
                  </div>
                  <div className="text-black-normal-f16-l28">{request.Symptoms}</div>
                </div>
              )}
            </div>
          </div>
          {/* <RequestItemLeaveComment sendMessage={sendMessage} /> */}
        </div>
        {/* <div className="boxes__col request-history">
          <div className="box">
            <div className="text-black-medium-f22-l30">Історія повідомлень</div>
            <RequestItemCommentList messages={messages} />
          </div>
        </div> */}
      </div>
      <Modal
        className="modal-type-green-close"
        open={loadingZoneModal}
        footer={null}
        onCancel={() => setLoadingZoneModal(false)}
        closeIcon={<Svg name="close-modal" />}
      >
        <div className="modal-type-green-close__wrapper">
          {imageLoadingZoneFull ? (
            <img
              className="loading-zone-img-modal"
              src={imageLoadingZoneFull}
              alt="Зона завантаження"
              style={{ maxWidth: '600px' }} // Большой размер в модальном окне
            />
          ) : (
            <div>Зображення недоступно</div>
          )}
          <Button
            type="submit"
            text="Завантажити"
            bg="pink"
            onClick={() => downloadFile(imageLoadingZoneFull, token)}
            disabled={!imageLoadingZoneFull}
          />
        </div>
      </Modal>
    </div>
  );
};

export default RequestItem;
